/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/**
 *
 * Component: Sider
 * Date: 22/1/2021
 *
 */

import React, { useCallback, useEffect, useState } from 'react';
import { Layout, Menu } from 'antd';
import mixpanel from 'utils/mixpanel';
import Text from 'components/common/Text';
import { PRODIGAL_LOGO_DARK } from 'utils/commonConstants';
import Icon from 'components/common/Icon';
import { Link, useLocation } from 'react-router-dom';
import styles from './style.module.css';
import { IMenu } from './interface';

const { SubMenu } = Menu;

const siderMenu: any[] = [
  {
    key: 'liveTab',
    path: '/live',
    icon: 'liveView',
    title: 'Live View',
  },
  {
    key: 'insightsTab',
    path: '/insights',
    icon: 'insightsView',
    title: 'Insights View',
  },
  {
    key: 'visualsTab',
    path: '/visuals',
    icon: 'visuals',
    title: 'Visuals',
  },
  // {
  //   key: 'configsTab',
  //   path: '/config',
  //   icon: 'admin',
  //   title: 'Configure',
  //   subMenu: [
  //     {
  //       key: 'configVisualTab',
  //       path: '/configVisual',
  //       icon: '',
  //       title: 'Visuals',
  //     },
  //   ],
  // },
];

const Sider = () => {
  const location = useLocation();
  const [collapsed, setcollapsed] = useState(false);

  const [selectedKeys, setSelectedKeys] = useState([] as any);
  const [openKeys, setOpenKeys] = useState([]);

  const onSelect = (selectedMenu: any) => {
    setSelectedKeys([selectedMenu.key]);
  };

  const onOpenChange = (selectedOpenKeys: any) => {
    setOpenKeys(selectedOpenKeys);
  };

  function createSubMenuList(menu: IMenu) {
    if (menu.subMenu && menu.subMenu.length > 0) {
      const subMenuLists =
        menu.subMenu.length &&
        menu.subMenu.map((subMenu) => {
          if (subMenu.subMenu && subMenu.subMenu.length) {
            return createSubMenuList(subMenu);
          }
          return (
            <Menu.Item key={subMenu.key}>
              <Link
                onClick={() =>
                  mixpanel('Sidebar clicked', menu.title, subMenu.title)
                }
                to={{
                  pathname: subMenu.path,
                  state: { title: subMenu.title, isSmartReport: true },
                }}
                className={styles.siderSubMenuStyles}
              >
                <Text type="Sider" text={subMenu.title} />
              </Link>
            </Menu.Item>
          );
        });

      return (
        <SubMenu
          className="sider-sub-menu"
          key={menu.key}
          title={
            <span>
              <Icon type={menu.icon} size={18} style={{ marginRight: 10 }} />
              <Text type="Sider" text={menu.title} />
            </span>
          }
        >
          {subMenuLists}
        </SubMenu>
      );
    }
    if (menu) {
      return (
        <Menu.Item key={menu.key}>
          <Link
            to={menu.path}
            onClick={() => {
              mixpanel('Tab Select', 'Side Menu', {
                userId: `${localStorage.getItem('userEmail')}`,
                switchedToTabName: menu.title,
              });
            }}
          >
            <div className={styles.menuItems}>
              <Icon
                type={menu.icon}
                size={18}
                style={{ margin: 0, marginRight: 10 }}
              />
              <Text type="Sider" text={menu.title} />
              {menu.beta ? (
                <span
                  className={styles.betaIcon}
                  style={{
                    marginLeft: collapsed ? -15 : 0,
                    marginTop: collapsed ? -15 : -10,
                  }}
                >
                  BETA
                </span>
              ) : null}
            </div>
          </Link>
        </Menu.Item>
      );
    }
    return <div />;
  }

  const menuList = siderMenu.map((menu: any) => createSubMenuList(menu));

  const handleInitialSelectedKey = useCallback(() => {
    const path = location.pathname;
    let isSiderLinkPresent = false;
    siderMenu.forEach((sider: { path: string; key: any }) => {
      if (sider.path && path.startsWith(sider.path)) {
        setSelectedKeys([sider.key]);
        isSiderLinkPresent = true;
      }
    });
    if (!isSiderLinkPresent) {
      setSelectedKeys([]);
    }
  }, [location, openKeys, siderMenu]);

  useEffect(() => {
    handleInitialSelectedKey();
  }, [location, handleInitialSelectedKey]);

  return (
    <div className={styles.container}>
      <Layout.Sider
        collapsible
        defaultCollapsed={
          !!(
            localStorage.getItem('collapsed') &&
            localStorage.getItem('collapsed') === 'true'
          )
        }
        collapsed={collapsed}
        trigger={null}
        className={collapsed ? styles.fixedSiderCollapsed : styles.fixedSider}
      >
        <div
          className={`${styles.logo} ${
            collapsed ? styles.centered : styles.leftAligned
          }`}
        >
          <div
            style={{
              width: collapsed ? '0px' : 'auto',
              overflow: 'hidden',
            }}
          >
            <img
              className={styles.logoImage}
              src={PRODIGAL_LOGO_DARK}
              alt="Logo"
              title="Supervisor"
            />
          </div>
          <div
            role="button"
            onClick={(e) => {
              e.stopPropagation();
              setcollapsed(!collapsed);
            }}
            aria-hidden="true"
            className={styles.siderCollapseTrigger}
          >
            {/* <Icon
               type="siderArrowLeft"
               size={10}
               rotate={collapsed ? 180 : 0}
               style={{
                 fontSize: 10,
                 display: 'block',
                 padding: '2px',
               }}
               useAntd
             /> */}
          </div>
        </div>
        {
          // custom openKeys functionality has some css bugs in Antd in collapsed state so not handeling it in collapsed state
        }
        {collapsed ? (
          <Menu
            theme="dark"
            mode="inline"
            inlineIndent={24}
            onSelect={onSelect}
            selectable
            onOpenChange={onOpenChange}
            selectedKeys={selectedKeys}
            inlineCollapsed={collapsed}
            triggerSubMenuAction="hover"
          >
            {menuList}
          </Menu>
        ) : (
          <Menu
            theme="dark"
            mode="inline"
            inlineIndent={24}
            onSelect={onSelect}
            selectable
            onOpenChange={onOpenChange}
            selectedKeys={selectedKeys}
            openKeys={openKeys}
            inlineCollapsed={collapsed}
            triggerSubMenuAction="hover"
          >
            {menuList}
          </Menu>
        )}
      </Layout.Sider>
    </div>
  );
};

export default Sider;
